/**
 * @fileoverview Phone number formatting helpers.
 *
 * Shared between the admin add/edit modals (live input masking) and the
 * read-only info modals / profile views (display formatting). Targets the
 * US format (XXX) XXX-XXXX.
 *
 * @version 1.0.0
 */

/**
 * Format a phone number for display as (XXX) XXX-XXXX.
 *
 * Returns an empty string for empty input, and the original string
 * unchanged if it does not contain exactly 10 digits (so extensions,
 * country codes, or other non-standard values are preserved as-is).
 *
 * @param {string} phone - Raw phone value
 * @return {string} Formatted (or original) phone string
 */
export const formatPhoneDisplay = (phone) => {
  if (!phone) return "";
  const cleaned = String(phone).replace(/\D/g, "");
  if (cleaned.length === 10) {
    return `(${cleaned.slice(0, 3)}) ${cleaned.slice(3, 6)}-${cleaned.slice(6)}`;
  }
  return phone;
};

/**
 * Progressively format phone input as the user types: (XXX) XXX-XXXX.
 *
 * Strips non-numeric characters, caps at 10 digits, and builds up the mask
 * as digits are entered. Returns an empty string for empty input.
 *
 * @param {string} value - Current input value
 * @return {string} Masked input value
 */
export const formatPhoneInput = (value) => {
  if (!value) return "";
  const digits = String(value).replace(/\D/g, "").slice(0, 10);
  if (digits.length <= 3) return digits;
  if (digits.length <= 6) return `(${digits.slice(0, 3)}) ${digits.slice(3)}`;
  return `(${digits.slice(0, 3)}) ${digits.slice(3, 6)}-${digits.slice(6)}`;
};
